<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>BESTÄLLNINGSHISTORIK</v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      </v-card-actions>

      <!-- Show machine qualification starts here -->
      <v-card-text class="mt-n6"> 
        <div v-for="p in printOrders" :key="p.id">
          <p>
            {{p.createdAt | date}}: Ett yrkesbeviskort har beställs till {{p.person | fullName}} (910103-1121), adress Björngatan 11, 44444
            OSBY, för maskinslag {{p.displayType}}
          </p>
        </div>
      </v-card-text>

      <v-card-actions class="justify-end mt-n6">
        <v-btn  color="primary" @click="$emit('close')"> <v-icon >$sl-cancel</v-icon>
        <div class="mr-5">
          OK
        </div>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api'
import get from 'lodash/get'
export default {
  name: 'showHistory',

  data() {
    return {
      printOrders: []
    }
  },
  watch: {
    showModal: function () {
      this.fetchPerson()
    },
  },
  props: {
    showModal: {
      type: Boolean    
    },
  },
  created() {
    this.fetchPerson()
  },

  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('app', ['isLoading'])
  },
  methods: {
    /**
     * @vuese
     * Used to fetch person
     * @arg The argument is integer values representing person id
     */
    fetchPerson() {
      this.printOrders = []
      API.getPersonPrintOrders(this.selectedPerson.id)
        .then(res => { 
          let type = ''
          let machines = ''
          res.data.forEach(p => {
            machines=''
            let machineCertificateMachines = get(p, 'print.machineCertificateMachines', [])
            if (machineCertificateMachines) {
              machineCertificateMachines.forEach(m => {
                if (machines != '') machines += ', '
                machines += m.machine.name
              })
              machines.replace(/\s*,\s*/g, ', ')
              type = 'Maskinkort:'
            }

            this.printOrders.push({
              id: p.id,
              printOrderState: p.printOrderState,
              createdBy: p.createdBy,
              createdAt: p.createdAt,
              displayType: machines,
              person:get(p, 'print.person', {})
            })
          })
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style>
</style>
